import React from "react";
import { XIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
import { CTAButton } from "../CTAButton";
import { reinventList } from "../../data/content";
export function NoMoreScratch() {
  return <Section tone="ink" data-id="element-183" data-mp="1uz16zhz0970w">
      <SectionHeading light kicker="Stop starting over" data-id="element-184" data-mp="1uzja8yk34lib">
        Don't keep building every class from scratch
      </SectionHeading>
      <p className="mt-6 text-center text-[17px] leading-relaxed text-white/85" data-id="element-185" data-mp="2mo4dl4ed6tgp">
        Every time you create another course, you shouldn't have to reinvent:
      </p>
      <ul className="mx-auto mt-6 grid max-w-xl gap-3 sm:grid-cols-2" data-id="element-186" data-mp="2rpjzeyod9405">
        {reinventList.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-white/10 px-4 py-3 text-[16px] font-medium" data-id="element-187" data-mp="2hxwc99yue94h">
            <XIcon className="h-4 w-4 shrink-0 text-petal" strokeWidth={3} aria-hidden="true" data-id="element-188" data-mp="35myrkb607pvt" />
            {item}
          </li>)}
      </ul>
      <p className="mt-10 text-center font-serif text-[26px] font-bold leading-snug md:text-4xl" data-id="element-189" data-mp="3afi6bbgfgr27">
        Build your system once.
        <br data-id="element-190" data-mp="28poqoq3cpcj" />
        <em className="text-petal" data-id="element-191" data-mp="297v4e6gwjy6">Then customize it for every new class you teach.</em>
      </p>
      <CTAButton label="I want my nail course system" data-id="element-192" data-mp="gy42sa4m3uy9" />
    </Section>;
}